import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { getPageApi } from '../../Api/ClientServices'
import TopNavbar from '../../Components/Navbar/TopNavbar'
import Style from './CustomePage.module.css'

const CustomePage = () => {
    useEffect(() => {
        getPageAbout()
    }, [])
    const[page,setPage]=useState()
    const getPageAbout=async()=>{
        const data=await getPageApi(window.location.pathname.split('/')[1])
        setPage(data)
    }

   
    return (
        <div className='pageHolder bg-light vh-100'>
            <TopNavbar/>
            <h3 className='w-100 text-center'>{page===undefined?'درحال دریافت لطفا منتظر باشید':<p className=' d-flex align-items-center justify-content-center'> <FontAwesomeIcon icon={faPaperclip} className='m-1' color='#c000b0'/> {page.title}</p>}</h3>
            
            <div className={`${Style.contentPage} `} dangerouslySetInnerHTML={{__html: page&&page.content}}></div>
        </div>
    )
}

export default CustomePage
